import React, { useState } from 'react';
import { Table, Button, Input, Select, Space, Card, Popconfirm } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { BiSolidShow } from 'react-icons/bi';
import { getSearchApi, getSearchApiAcount } from '../../../network/itemList';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useQuery } from '@tanstack/react-query';
const TaxtList = ({ t, dataSource, setDataSource }) => {
  const [count, setCount] = useState();
  const [searchTxt, setSearchTxt] = useState('');
  // const { data: account } = useQuery({
  //   queryKey: [queryKeys.getSearchApiAccount],
  //   queryFn: () => getSearchApi('Account'),
  //   keepPreviousData: true,
  // });
  const { data: payrollcostcenter } = useQuery({
    queryKey: [queryKeys.getCostCenterSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount, searchTxt],
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchTxt }),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.expenseAccount,
      dataIndex: 'expense_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.DefaultAccount}
          value={record?.expense_account}
          style={{ width: '100%' }}
          showSearch
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setSearchTxt(value);
          }}
          filterOption={false}
          allowClear
          onClear={() => {
            setSearchTxt('');
          }}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              expense_account: value,
            };
            setDataSource(newDataSource);
          }}
          options={account?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          value={record?.amount}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              amount: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.description,
      dataIndex: 'description',
      render: (text, record, index) => (
        <Input
          placeholder={t.description}
          value={record?.description}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              description: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.costCenter,
    //   dataIndex: 'cost_center',
    //   render: (text, record, index) => (
    //     <Select
    //       placeholder={t.costCenter}
    //       value={record.cost_center}
    //       popupMatchSelectWidth={false}
    //       onChange={(value) => {
    //         const newDataSource = [...dataSource];
    //         newDataSource[index] = {
    //           ...newDataSource[index],
    //           cost_center: value,
    //         };
    //         setDataSource(newDataSource);
    //       }}
    //       style={{ width: '100%' }}
    //       options={payrollcostcenter?.message?.map((user) => ({
    //         value: user.value,
    //         label: user.value,
    //       }))}
    //     />
    //   ),
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        // loading={loadingTaxesDetails}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};
export default TaxtList;
